import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import qbIcon from "../../../assets/images/quickbooks/QB_16x16.png";
import IOrder from "../../../models/IOrder";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IPurchaseOrderOrderItemDetail from "../../../models/IPurchaseOrderOrderItemDetail";
import IPurchaseOrderOrderItemDetailUI from "../../../models/IPurchaseOrderOrderItemDetailUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OrderEntryService from "../../../services/OrderEntryService";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./OrderActionColumn.scss";
import OwButton from "../../shared/OwButton/OwButton";
import IVendor_Source from "../../../models/IVendor_Source";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import ICatalog_Item_Vendor_Source_Map from "../../../models/ICatalog_Item_Vendor_Source_Map";
import UIService from "../../../services/UIService";
import IKitDetails from "../../../models/IKitDetails";
import UserTypesEnum from "../../../models/UserTypesEnum";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../shared/OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    data: IOrder_ItemUI;
    index: number;
    isManualPrice: boolean;
    order?: IOrder;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    showQuickBooksNotConnected?: boolean;
    toggleResetItemToCatalogDefaultFn: (row: IOrder_ItemUI) => void;
    viewChildItems: (row: IOrder_ItemUI, index: number) => void;
    toggleRowDetailViewFn: any;
    toggleRowEditModeFn: ProcessOrderEntryItemFn;
    toggleConfirmDeleteFn: (e: any, data: IOrder_ItemUI, index: number, ref: React.Ref<HTMLElement>) => void;
    rowRef: React.Ref<any>;
    isReadOnly: boolean;
    isBackorderView: boolean;
    checkRowForBackorder: (orderItemGuid: string, isChecked: boolean, qty: number) => void;
    // isPurchaseOrderView: boolean;
    // purchaseOrderRows: IPurchaseOrderOrderItemDetail[];
    // checkRowForPurchaseOrder: (orderItemGuid: string, isChecked: boolean, qty: number, vendorSource?: number) => void;
    // vendorSourcesForCatalogItems?: { [key: string]: IVendor_Source[] };
    isAcknowledgeView: boolean;
    checkRowForAcknowledge: (orderItemGuid: string, isChecked: boolean, qty: number) => void;
    acknowledgeRows: { qty: number; orderItemGuid: string; isChecked: boolean }[];
};

type State = {
    rowIsChecked: boolean;
    backorderQty: number;
    ackQty: number;
    // purchaseOrderQty: number;
    // purchaseOrderRow: IPurchaseOrderOrderItemDetailUI;
    // availableVendorSourcesForCatalogItem: IVendor_Source[];
    // selectedVendorSource?: IVendor_Source;
    // selectedVendorSourceMap?: ICatalog_Item_Vendor_Source_Map;
    originalRowData: IOrder_ItemUI;
};

class OrderActionColumn extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        // if (this.props.purchaseOrderRows) {
        //     for (let row of this.props.purchaseOrderRows) {
        //         if (row.orderItemGuid === this.props.data.guid) {
        //             purchaseOrderRow = row as IPurchaseOrderOrderItemDetailUI;
        //             purchaseOrderRow.hasVendorSource = true;
        //             // console.log('purchaseOrderRow', purchaseOrderRow);
        //         }
        //     }
        // }

        this.state = {
            ackQty: this.props.data.qty,
            rowIsChecked: false,
            backorderQty: 0,
            // purchaseOrderQty: 0,
            // purchaseOrderRow,
            // availableVendorSourcesForCatalogItem: [],
            originalRowData: { ...this.props.data },
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        // if (prevProps.purchaseOrderRows !== this.props.purchaseOrderRows) {
        //     let purchaseOrderRow: IPurchaseOrderOrderItemDetailUI = {
        //         isChecked: false,
        //         orderItemGuid: "",
        //         minQty: 0,
        //         qty: 0,
        //     } as IPurchaseOrderOrderItemDetailUI;
        //
        //     if (this.props.purchaseOrderRows) {
        //         for (let row of this.props.purchaseOrderRows) {
        //             if (row.orderItemGuid === this.props.data.guid) {
        //                 purchaseOrderRow = row as IPurchaseOrderOrderItemDetailUI;
        //                 purchaseOrderRow.hasVendorSource = true;
        //                 console.log("purchaseOrderRow", purchaseOrderRow);
        //             }
        //         }
        //     }
        //
        //     this.setState({
        //         purchaseOrderRow,
        //     });
        // }
        // if (prevProps.vendorSourcesForCatalogItems !== this.props.vendorSourcesForCatalogItems) {
        //     console.log("Vendor Sources For Catalog Items: ", this.props.vendorSourcesForCatalogItems);
        //     if (this.props.vendorSourcesForCatalogItems) {
        //         for (const catalogItemGuid of Object.keys(this.props.vendorSourcesForCatalogItems)) {
        //             const vendorSourceDetail = this.props.vendorSourcesForCatalogItems[catalogItemGuid];
        //
        //             if (catalogItemGuid === this.props.data.Catalog_Item!.guid) {
        //                 this.setState({
        //                     availableVendorSourcesForCatalogItem: vendorSourceDetail,
        //                 });
        //             }
        //         }
        //     }
        // }
    }

    checkRowForBackorder = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        this.setState(
            {
                rowIsChecked: value,
            },
            () => {
                this.props.checkRowForBackorder(this.props.data.guid, this.state.rowIsChecked, this.state.backorderQty);
            }
        );
    };

    checkRowForAcknowledge = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        this.setState(
            {
                rowIsChecked: value,
            },
            () => {
                this.props.checkRowForAcknowledge(this.props.data.guid, this.state.rowIsChecked, this.state.ackQty);
            }
        );
    };

    // checkRowForPurchaseOrder = (e: ChangeEvent<any>) => {
    //     const value = e.target.type === "checked" ? e.target.checked : e.target.value;
    //     const name = e.target.name;
    //
    //     let purchaseOrderRow = this.state.purchaseOrderRow;
    //
    //     purchaseOrderRow.isChecked = value;
    //
    //     this.setState(
    //         {
    //             rowIsChecked: value,
    //             purchaseOrderRow,
    //         },
    //         () => {
    //             this.props.checkRowForPurchaseOrder(
    //                 this.props.data.guid,
    //                 this.state.rowIsChecked,
    //                 this.state.purchaseOrderQty,
    //                 this.state.selectedVendorSource?.id
    //             );
    //         }
    //     );
    // };

    handleBackorderQtyChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        this.setState(
            {
                backorderQty: value,
            },
            () => {
                this.props.checkRowForBackorder(this.props.data.guid, this.state.rowIsChecked, this.state.backorderQty);
            }
        );
    };

    handleAckQtyChange = (e: ChangeEvent<any>) => {
        let value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        value = Number(value);

        if (value < 0) {
            value = 0;
        } else {
            if (value > this.props.data.qty) {
                value = this.props.data.qty;
            }
        }

        this.setState(
            {
                ackQty: value,
            },
            () => {
                this.props.checkRowForAcknowledge(this.props.data.guid, this.state.rowIsChecked, this.state.ackQty);
            }
        );
    };

    render() {
        let allowEditing = false;

        if (this.props.order) {
            // // Initial State for Most limited user.
            // switch (this.props.order.order_state_id) {
            //     case OrderStateEnum.PRELIMINARY:
            //     case OrderStateEnum.SUBMITTED:
            //         allowEditing = true;
            //         break;
            //
            //     default:
            //         allowEditing = false;
            //         break;
            // }

            if (!this.props.isReadOnly) {
                // console.log("allowEditing");
                allowEditing = true;

                if (this.props.data.is_ratio_item) {
                    if (this.props.userModel.isSupplierUser) {
                        if (this.props.userModel.supplierUserToken?.user_type_id !== UserTypesEnum.ADMIN) {
                            allowEditing = false;
                        }
                    } else {
                        allowEditing = false;
                    }
                }
            }

            if (this.props.isBackorderView) {
                allowEditing = false;
            }

            // if (this.props.isPurchaseOrderView) {
            //     allowEditing = false;
            // }
        }

        const is_quickbooks_connected = !!_.get(this.props.data, "Catalog_Item.qbo_item_id", false);
        // console.log('is_quickbooks_connected', is_quickbooks_connected);

        let rowHasIssue = false;

        if (this.props.showQuickBooksNotConnected && !is_quickbooks_connected) {
            rowHasIssue = true;
        }

        const showDetailView = this.props.data.Catalog_Item
            ? this.props.data.Catalog_Item.require_addl_input
            : this.props.data.showDetailView;

        const textMuted = "pointer";
        let disableSave = false;

        const orderModel = this.props.order || ({} as IOrder);

        const { enableAdd } = OrderEntryService.doInventoryValidation(
            this.props.data.Catalog_Item!,
            this.props.data.qty,
            this.props.order?.Order_Items || [],
            this.props.supplierModel,
            orderModel,
            0,
            this.props.data.Selected_Unit
        );

        if (this.props.data.Catalog_Item?.min_order_qty) {
            if (!enableAdd) {
                disableSave = true;
            }
        }

        return (
            <div className={"OrderActionColumn d-flex align-items-center"}>
                <div className={"state-circle me-4 " + (this.props.data.isSaved ? "bluish-green-bg" : "red-bg")} />

                <i className={"fad fa-exclamation-triangle text-warning " + (rowHasIssue ? "" : "invisible")}></i>

                <div className={showDetailView ? "" : "invisible"}>
                    <i
                        className="far fa-chevron-down pointer"
                        onClick={() => {
                            this.props.toggleRowDetailViewFn(this.props.data, this.props.index);
                        }}
                    />
                </div>

                {this.props.isAcknowledgeView ? (
                    <div className={"d-flex align-items-center"}>
                        <OwCheckbox
                            name={"orderItemGuid"}
                            fn={this.checkRowForAcknowledge}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.rowIsChecked}
                        />
                        {!this.state.rowIsChecked ? null : (
                            <div className={"ms-2 w-10r d-flex align-items-center"}>
                                <OwLabel title={"qty"} noBottomMargin={true} className={"me-2"} />
                                <OwInputWrapper
                                    name={"ackQty"}
                                    type={"number"}
                                    value={this.state.ackQty}
                                    fn={this.handleAckQtyChange}
                                    onWheelFn={UIService.stopScrollWheel}
                                />
                            </div>
                        )}
                    </div>
                ) : null}

                {this.props.isBackorderView ? (
                    <div className={"d-flex align-items-center"}>
                        <OwCheckbox
                            name={"orderItemGuid"}
                            fn={this.checkRowForBackorder}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.rowIsChecked}
                        />
                        {!this.state.rowIsChecked ? null : (
                            <div className={"ms-2 w-10r d-flex align-items-center"}>
                                <OwLabel title={"qty"} noBottomMargin={true} className={"me-2"} />
                                <OwInputWrapper
                                    name={"backorderQty"}
                                    type={"number"}
                                    value={this.state.backorderQty}
                                    fn={this.handleBackorderQtyChange}
                                    onWheelFn={UIService.stopScrollWheel}
                                />
                            </div>
                        )}
                    </div>
                ) : null}

                <div className={"itemRowActions " + (allowEditing ? "" : "d-none")}>
                    <OwDeleteEditActions
                        isEditMode={this.props.data.rowEditMode}
                        onTrashClickFn={(e) => {
                            this.props.toggleConfirmDeleteFn(e, this.props.data, this.props.index, this.props.rowRef);
                        }}
                        onEditClickFn={() => {
                            this.props.toggleRowEditModeFn(this.props.data, {});
                        }}
                    />
                    <OwAcceptCancelActions
                        isEditMode={!this.props.data.rowEditMode}
                        disableAccept={disableSave}
                        onAcceptClickFn={() => {
                            if (!disableSave) {
                                this.props.toggleRowEditModeFn(this.props.data, { shouldAutoSave: true });
                            }
                        }}
                        onCancelClickFn={() => {
                            this.props.toggleRowEditModeFn(this.state.originalRowData, { shouldAutoSave: false });
                        }}
                    />
                    {this.props.supplierModel.has_child_items && this.props.data.Catalog_Item?.has_child_items ? (
                        <div className={this.props.data.rowEditMode ? "d-none" : ""}>
                            {/*<i*/}
                            {/*    className="fa-duotone fa-shapes pointer text-primary"*/}
                            {/*    title="Add Child Items"*/}
                            {/*    onClick={() => {*/}
                            {/*        this.props.viewChildItems(this.props.data, this.props.index);*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <OwButton
                                leftIconClass={"fas fa-plus"}
                                title={"child_items"}
                                className={"mt-2 btn-warning btn-sm"}
                                fn={() => {
                                    this.props.viewChildItems(this.props.data, this.props.index);
                                }}
                            />
                        </div>
                    ) : null}
                </div>

                <div className={this.props.data.rowEditMode && this.props.isManualPrice ? "mx-3" : "d-none"}>
                    <OwButton
                        className="btn-warning"
                        centerIconClass="far fa-undo pointer"
                        hoverTitle="Reset to Default Catalog Price"
                        fn={() => {
                            this.props.toggleResetItemToCatalogDefaultFn(this.props.data);
                        }}
                    />
                </div>

                <div className={"" + (this.props.showQuickBooksNotConnected ? "" : "d-none")}>
                    <div className={is_quickbooks_connected ? "d-none" : "ms-2"}>
                        <img src={qbIcon} className={"dimmed ms-2"} title={"Not QuickBooks Online Connected"} />
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderActionColumn;
